<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">Edit Category</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <form
        [formGroup]="editCategoryForm"
        (ngSubmit)="saveCategory()"
        novalidate
      >
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field *ngIf="productOptions.length > 0" color="accent">
              <mat-label>Product</mat-label>
              <mat-select formControlName="productId" required>
                <mat-option [value]="null">Select an option</mat-option>
                <mat-option
                  *ngFor="let product of productOptions; let i = index"
                  [value]="product.productId"
                >
                  {{ product.productName }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="editCategoryForm.get('productId').hasError('required')"
              >
                Product is required.</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field color="accent">
              <mat-label>Category Name</mat-label>
              <input
                matInput
                type="text"
                placeholder="categoryName"
                name="categoryName"
                [placeholder]="'Category'"
                formControlName="categoryName"
                required
                pattern=".*\S.*"
              />
              <mat-error
                *ngIf="
                  editCategoryForm.get('categoryName').hasError('required')
                "
              >
                Category Name is required.
              </mat-error>
              <mat-error
                *ngIf="
                  editCategoryForm.get('categoryName').hasError('maxlength')
                "
              >
                Category Name cannot be more than 50 characters.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-6 col-md-4">
            <mat-form-field color="accent">
              <mat-label>Description</mat-label>
              <input
                matInput
                type="text"
                name="description"
                formControlName="description"
                [placeholder]="'Description'"
                required
                pattern=".*\S.*"
              />
              <mat-error
                *ngIf="editCategoryForm.get('description').hasError('required')"
              >
                Description is required.
              </mat-error>
              <mat-error
                *ngIf="
                  editCategoryForm.get('description').hasError('maxlength')
                "
              >
                Description cannot be more than 100 characters.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <div class="row action-btn">
          <button
            md-raised-button
            type="button"
            class="btn btn-rose"
            (click)="close()"
          >
            Close
          </button>
          <button
            md-raised-button
            type="button"
            class="btn btn-rose"
            (click)="saveCategory()"
            [disabled]="!editCategoryForm.valid || !editCategory.productId"
          >
            Update
          </button>
        </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
